import { render } from "./About.vue?vue&type=template&id=541b4d18"
const script = {}
script.render = render

export default script